export default {
  mounted(el, binding) {
    let startX = 0
    let startY = 0
    let isDragging = false
    const threshold = 50

    // Check if we should enable swipe (small screen + binding exists)
    function shouldEnableSwipe() {
      const isSmallScreen = globalThis.matchMedia('(max-width: 768px)').matches
      const hasBinding = typeof binding.value === 'function'
      return isSmallScreen && hasBinding
    }

    // Touch handlers
    function handleTouchStart(event) {
      if (!shouldEnableSwipe()) return

      startX = event.touches[0].clientX
      startY = event.touches[0].clientY
      isDragging = true
      el.style.cursor = 'grabbing'
    }

    function handleTouchMove(event) {
      if (!isDragging || !shouldEnableSwipe()) return

      const currentX = event.touches[0].clientX
      const currentY = event.touches[0].clientY
      const deltaX = Math.abs(currentX - startX)
      const deltaY = Math.abs(currentY - startY)

      if (deltaX > 10 && deltaX > deltaY) {
        event.preventDefault()
      }
    }

    function handleTouchEnd(event) {
      if (!isDragging || !shouldEnableSwipe()) return

      const endX = event.changedTouches[0].clientX
      const deltaX = endX - startX

      isDragging = false
      el.style.cursor = shouldEnableSwipe() ? 'grab' : 'default'

      if (Math.abs(deltaX) > threshold && binding.value) {
        if (deltaX > 0) {
          binding.value('prev')
        } else {
          binding.value('next')
        }
      }
    }

    // Mouse handlers (for browser dev tools)
    function handleMouseDown(event) {
      if (!shouldEnableSwipe()) return

      startX = event.clientX
      startY = event.clientY
      isDragging = true
      el.style.cursor = 'grabbing'

      // Add document listeners for proper mouse dragging
      document.addEventListener('mousemove', handleMouseMove, { passive: false })
      document.addEventListener('mouseup', handleMouseUp, { passive: true })
      event.preventDefault()
    }

    function handleMouseMove(event) {
      if (!isDragging || !shouldEnableSwipe()) return

      const currentX = event.clientX
      const currentY = event.clientY
      const deltaX = Math.abs(currentX - startX)
      const deltaY = Math.abs(currentY - startY)

      if (deltaX > 10 && deltaX > deltaY) {
        event.preventDefault()
      }
    }

    function handleMouseUp(event) {
      if (!isDragging || !shouldEnableSwipe()) return

      const endX = event.clientX
      const deltaX = endX - startX

      isDragging = false
      el.style.cursor = shouldEnableSwipe() ? 'grab' : 'default'

      // Clean up document listeners
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)

      if (Math.abs(deltaX) > threshold && binding.value) {
        if (deltaX > 0) {
          binding.value('prev')
        } else {
          binding.value('next')
        }
      }
    }

    // Set initial styles
    function updateStyles() {
      const enabled = shouldEnableSwipe()
      el.style.cursor = enabled ? 'grab' : 'default'
      el.style.userSelect = enabled ? 'none' : 'auto'
    }

    updateStyles()

    // Add event listeners
    el.addEventListener('touchstart', handleTouchStart, { passive: true })
    el.addEventListener('touchmove', handleTouchMove, { passive: false })
    el.addEventListener('touchend', handleTouchEnd, { passive: true })
    el.addEventListener('mousedown', handleMouseDown)

    // Handle window resize
    function handleResize() {
      updateStyles()
    }

    globalThis.addEventListener('resize', handleResize)

    // Store cleanup function
    el._swipeCleanup = () => {
      el.removeEventListener('touchstart', handleTouchStart)
      el.removeEventListener('touchmove', handleTouchMove)
      el.removeEventListener('touchend', handleTouchEnd)
      el.removeEventListener('mousedown', handleMouseDown)
      globalThis.removeEventListener('resize', handleResize)

      // Clean up document listeners
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }
  },

  unmounted(el) {
    if (el._swipeCleanup) {
      el._swipeCleanup()
    }
  },
}
